// extracted by mini-css-extract-plugin
export default {"azureButton":"azure-login-button_azureButton__9aVnL"};